import { 
    hasValue,
    findElementByProperty,
    getProperty,
    getObjectKeyByValue,
    isNullOrUndefined
} from "../../../../../../general/js/general-helpers";
import { formMessageConstants } from "../../../utils/constants/form-message-constants";
import { formFieldConstants } from "../../../utils/constants/form-field-constants";
import { ssoFieldTypes } from "../../../utils/field-types";
import { ssoFormTypes } from "../../../utils/form-types";

export const findOptionInSelectField = (selectField = {}, optionValue = '', propertyToReturn = '') => {
    if(!hasValue(selectField) || !hasValue(optionValue)){
        return formMessageConstants.emptyString;
    }

    const { options } = selectField;
    
    if(!hasValue(options)){
        return formMessageConstants.emptyString;
    }

    let selectedOption = findElementByProperty(options, formFieldConstants.selectFieldOptionsCode, optionValue);

    if (hasValue(selectedOption))
        return hasValue(propertyToReturn) ? getProperty(selectedOption, propertyToReturn) : selectedOption;

    selectedOption = findElementByProperty(options, formFieldConstants.selectFieldOptionsLabel, optionValue);

    return hasValue(propertyToReturn) ? getProperty(selectedOption, propertyToReturn) : selectedOption;
};

export const isTextAndImageField = (formDataKey = '') => {
    if(!hasValue(formDataKey)){
        return false;
    }

    const ssoFieldType = getObjectKeyByValue(ssoFieldTypes, ssoFieldTypes.TextAndImageTile).toLowerCase();


    return formDataKey.toLowerCase().includes(ssoFieldType);
}

export const hasFormFields = (formData = {}) => {
    if(!hasValue(formData)){
        return false;
    }

    var fields = Object.entries(formData).filter(([key, value]) => !isNullOrUndefined(value) && !isNullOrUndefined(value.fieldType));

    if(!hasValue(fields)){
        return false;
    }

    return true;
}

export const isBallotForm = (formType = null) => {
    if(!hasValue(formType)){
        return false;
    }

    return formType === ssoFormTypes.BallotSummaryForm
        || formType === ssoFormTypes.BallotLiteRegister
        || formType === ssoFormTypes.BallotFullRegister
        || formType === ssoFormTypes.BallotSignInForm
        || formType === ssoFormTypes.BallotForgotPassword;
};